import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mx-auto max-w-4xl divide-y divide-gray-900/10" }
const _hoisted_3 = { class: "mt-10 space-y-2 divide-y divide-gray-900/10" }
const _hoisted_4 = { class: "text-base font-semibold text-sm" }
const _hoisted_5 = { class: "ml-6 flex h-7 items-center" }
const _hoisted_6 = ["innerHTML"]

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDoubleDownIcon, MinusSmIcon } from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsConditions',
  setup(__props) {

const faqs = [
  {
    question: "Terms & Conditions",
    answer:
      "A minimum two night stay is required. A 20% deposit on your entire stay is necessary to confirm your reservation. Check in time: 3pm; Check out time: 11am; with flexibility applied by onsite manager.",
  },
  {
    question: "Discounts",
    answer:
      "A 10% discount is available to repeat guests. Discounts are not additive. They are applied by the manager upon payment of the final balance.",
  },
  {
    question: "Payment",
    answer:
      "Bookings can be secured through online credit card payment, by a deposit made in cash, cheque, money order or bank to bank transfer of funds. Contact the Manager for details. - Balance is payable on arrival. Online payments are charged in US dollars.",
  },
  {
    question: "Cancellation",
    answer:
      "Cancellations more than 60 days before check in or within 2 days of booking: full refund of deposit.<br />Cancellations between 7 and 60 days before check in: refund of 50% of deposit.<br />Cancellations less than 7 days: no refund.<br />Alternatively, all deposits can be used towards a future stay at Top O' Tobago within one year of cancellation.",
  },



];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dl", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(faqs, (faq) => {
          return _createVNode(_unref(Disclosure), {
            as: "div",
            key: faq.question,
            class: "pt-2"
          }, {
            default: _withCtx(({ open }) => [
              _createElementVNode("dt", null, [
                _createVNode(_unref(DisclosureButton), { class: "flex w-full items-start justify-between text-left text-gray-900" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(faq.question), 1),
                    _createElementVNode("span", _hoisted_5, [
                      (!open)
                        ? (_openBlock(), _createBlock(_unref(ChevronDoubleDownIcon), {
                            key: 0,
                            class: "h-4 w-4",
                            "aria-hidden": "true"
                          }))
                        : (_openBlock(), _createBlock(_unref(MinusSmIcon), {
                            key: 1,
                            class: "h-6 w-6",
                            "aria-hidden": "true"
                          }))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_unref(DisclosurePanel), {
                as: "dd",
                class: "mt-2 pr-12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "text-base text-sm leading-2 text-gray-600",
                    innerHTML: faq.answer
                  }, null, 8, _hoisted_6)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ])
    ])
  ]))
}
}

})